// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__-ESDC.styles_ocean-50__Zb3Ci {
  color: #e6f2ff;
}

.styles_color__-ESDC.styles_ocean-100__Xpo7V {
  color: #e6f2ff;
}

.styles_color__-ESDC.styles_ocean-200__v7GHb {
  color: #b3daff;
}

.styles_color__-ESDC.styles_ocean-300__OSWri {
  color: #7abfff;
}

.styles_color__-ESDC.styles_ocean-400__1MLIl {
  color: #2392fb;
}

.styles_color__-ESDC.styles_ocean-500__EjCkT {
  color: #0074e0;
}

.styles_color__-ESDC.styles_ocean-600__oXSVH {
  color: #043571;
}

.styles_color__-ESDC.styles_space-50__rO64w {
  color: #f0f0f0;
}

.styles_color__-ESDC.styles_space-100__v0ff9 {
  color: #e3e3e3;
}

.styles_color__-ESDC.styles_space-200__LuWLo {
  color: #bfbfbf;
}

.styles_color__-ESDC.styles_space-300__znA05 {
  color: gray;
}

.styles_color__-ESDC.styles_space-400__3ws1r {
  color: #616161;
}

.styles_color__-ESDC.styles_space-500__YkJEF {
  color: #283439;
}

.styles_color__-ESDC.styles_gray-50__LJAPl {
  color: #eff3f6;
}

.styles_color__-ESDC.styles_gray-100__-pneb {
  color: #e6ecef;
}

.styles_color__-ESDC.styles_gray-200__6LaGp {
  color: #cfd8de;
}

.styles_color__-ESDC.styles_gray-300__IdnRw {
  color: #a8b9c2;
}

.styles_color__-ESDC.styles_gray-400__rPE-0 {
  color: #7e98a5;
}

.styles_color__-ESDC.styles_gray-500__7Blft {
  color: #738f9c;
}

.styles_color__-ESDC.styles_green-50__\\+aSyG {
  color: #e3fdf6;
}

.styles_color__-ESDC.styles_green-100__K7Xes {
  color: #c5f6ea;
}

.styles_color__-ESDC.styles_green-200__l6WYw {
  color: #69ddc2;
}

.styles_color__-ESDC.styles_green-300__-fh4s {
  color: #45bfa3;
}

.styles_color__-ESDC.styles_green-400__9OJvW {
  color: #1cab8a;
}

.styles_color__-ESDC.styles_green-500__VH5rk {
  color: #128268;
}

.styles_color__-ESDC.styles_red-50__mVc0\\+ {
  color: #fff0f3;
}

.styles_color__-ESDC.styles_red-100__Y08IO {
  color: #f9d2db;
}

.styles_color__-ESDC.styles_red-200__c1rI4 {
  color: #f8b4c4;
}

.styles_color__-ESDC.styles_red-300__mu-8c {
  color: #e85e81;
}

.styles_color__-ESDC.styles_red-400__0Mk2g {
  color: #e23661;
}

.styles_color__-ESDC.styles_red-500__H0asz {
  color: #b82348;
}

.styles_color__-ESDC.styles_yellow-50__CaR5a {
  color: #fffae6;
}

.styles_color__-ESDC.styles_yellow-100__sUjoV {
  color: #fff0b3;
}

.styles_color__-ESDC.styles_yellow-200__NdrML {
  color: #ffe380;
}

.styles_color__-ESDC.styles_yellow-300__VU-\\+6 {
  color: #ffcf57;
}

.styles_color__-ESDC.styles_yellow-400__SIp2o {
  color: #ffc60a;
}

.styles_color__-ESDC.styles_yellow-500__\\+1i8I {
  color: #ffb700;
}

.styles_color__-ESDC.styles_orange-50__rMEMQ {
  color: #fff2eb;
}

.styles_color__-ESDC.styles_orange-100__qaLQi {
  color: #ffe4d6;
}

.styles_color__-ESDC.styles_orange-200__a\\+ToD {
  color: #ffc69e;
}

.styles_color__-ESDC.styles_orange-300__mF4DN {
  color: #ffa047;
}

.styles_color__-ESDC.styles_orange-400__HHTf4 {
  color: #ff7b42;
}

.styles_color__-ESDC.styles_orange-500__3p6ey {
  color: #ee4920;
}

.styles_color__-ESDC.styles_turquoise-50__VDjn2 {
  color: transparent;
}

.styles_color__-ESDC.styles_turquoise-100__6xfKi {
  color: #e6fcff;
}

.styles_color__-ESDC.styles_turquoise-200__C0qxm {
  color: #b3f5ff;
}

.styles_color__-ESDC.styles_turquoise-300__A5TWM {
  color: #78e2f2;
}

.styles_color__-ESDC.styles_turquoise-400__tktt6 {
  color: #00c7e6;
}

.styles_color__-ESDC.styles_turquoise-500__3j-fZ {
  color: transparent;
}

.styles_color__-ESDC.styles_turquoise-600__z9g4o {
  color: transparent;
}

.styles_color__-ESDC.styles_violet-50__5F6fT {
  color: #eae6ff;
}

.styles_color__-ESDC.styles_violet-100__PN65M {
  color: #d9d1ff;
}

.styles_color__-ESDC.styles_violet-200__V4XwS {
  color: #bfb3ff;
}

.styles_color__-ESDC.styles_violet-300__vt-MA {
  color: #9d90ea;
}

.styles_color__-ESDC.styles_violet-400__772O4 {
  color: #8678d9;
}

.styles_color__-ESDC.styles_violet-500__ulpDo {
  color: #6f5ccc;
}

.styles_color__-ESDC.styles_snow-50__RqKI3 {
  color: white;
}

.styles_color__-ESDC.styles_snow-100__vNOD3 {
  color: #f7f7f7;
}

.styles_color__-ESDC.styles_snow-200__FuZ\\+d {
  color: #f0efef;
}

.styles_color__-ESDC.styles_snow-300__B5VWq {
  color: #e6e6e6;
}

.styles_color__-ESDC.styles_snow-400__3i4ch {
  color: #e1e0e0;
}

.styles_color__-ESDC.styles_snow-500__E11cZ {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__R77OE.styles_ocean__SIBg3 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__R77OE.styles_ocean-light__XIZaS {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__R77OE.styles_green__5\\+gQ\\+ {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__R77OE.styles_green-light__xygeh {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__R77OE.styles_red__1m\\+wi {
  background-color: #e23661;
  color: white;
}

.styles_background-color__R77OE.styles_red-light__Gh6Yb {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__R77OE.styles_orange__K6JZS {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__R77OE.styles_orange-light__U5IbR {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__R77OE.styles_space__WWdql {
  background-color: #616161;
  color: white;
}

.styles_background-color__R77OE.styles_space-light__MOUG- {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__R77OE.styles_gray-light__Qa1xJ {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__R77OE.styles_violet__GWvJj {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__R77OE.styles_violet-light__Y9ry9 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__R77OE.styles_yellow__y5Gxe {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__R77OE.styles_yellow-light__kAOV2 {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__WT9JN {
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  background-color: #f7f7f7;
  border-radius: 5px;
}
.styles_root__WT9JN::-moz-focus-inner {
  border-style: none;
}
.styles_root__WT9JN svg {
  color: gray;
}
.styles_root__WT9JN.styles_circular__PtEtM {
  border-radius: 50%;
}
.styles_root__WT9JN.styles_fab__unop9 {
  position: absolute;
}
.styles_root__WT9JN.styles_fab__unop9.styles_top__BBlVW {
  top: 8px ;
}
.styles_root__WT9JN.styles_fab__unop9.styles_left__cjlrG {
  left: 8px ;
}
.styles_root__WT9JN.styles_fab__unop9.styles_right__cslSk {
  right: 8px ;
}
.styles_root__WT9JN.styles_fab__unop9.styles_bottom__3Vn5S {
  bottom: 8px ;
}
.styles_root__WT9JN.styles_primary__7KgxL {
  background-color: #0074e0;
}
.styles_root__WT9JN.styles_primary__7KgxL svg {
  color: white;
}
.styles_root__WT9JN.styles_secondary__3pEIA {
  background-color: #b3daff;
}
.styles_root__WT9JN.styles_secondary__3pEIA svg {
  color: #0074e0;
}
.styles_root__WT9JN.styles_ghost__qunSQ {
  background-color: transparent;
}
.styles_root__WT9JN.styles_ghost__qunSQ svg {
  color: #7e98a5;
}
.styles_root__WT9JN.styles_error__hig-v {
  background-color: white;
}
.styles_root__WT9JN.styles_error__hig-v svg {
  color: #b82348;
}
.styles_root__WT9JN.styles_formatting__pzPJm {
  background-color: transparent;
}
.styles_root__WT9JN.styles_formatting__pzPJm svg {
  color: #283439;
}
.styles_root__WT9JN[disabled] svg, .styles_root__WT9JN:disabled svg {
  color: #bfbfbf;
}
.styles_root__WT9JN.styles_border__evxv3 {
  background-color: white;
  border: 1px solid #e6ecef;
}
.styles_root__WT9JN.styles_border__evxv3 svg {
  color: #a8b9c2;
}
.styles_root__WT9JN:hover {
  background-color: #f0efef;
}
.styles_root__WT9JN:hover svg {
  color: gray;
}
.styles_root__WT9JN:hover.styles_primary__7KgxL {
  background-color: #2392fb;
}
.styles_root__WT9JN:hover.styles_primary__7KgxL svg {
  color: white;
}
.styles_root__WT9JN:hover.styles_secondary__3pEIA {
  background-color: #e6f2ff;
}
.styles_root__WT9JN:hover.styles_secondary__3pEIA svg {
  color: #2392fb;
}
.styles_root__WT9JN:hover.styles_ghost__qunSQ {
  background-color: #eff3f6;
}
.styles_root__WT9JN:hover.styles_ghost__qunSQ svg {
  color: #7e98a5;
}
.styles_root__WT9JN:hover.styles_error__hig-v {
  background-color: white;
}
.styles_root__WT9JN:hover.styles_error__hig-v svg {
  color: #b82348;
}
.styles_root__WT9JN:hover.styles_border__evxv3 {
  background-color: #e6f2ff;
}
.styles_root__WT9JN:hover.styles_border__evxv3 svg {
  color: #738f9c;
}
.styles_root__WT9JN:hover.styles_formatting__pzPJm {
  background-color: #eff3f6;
}
.styles_root__WT9JN:hover.styles_formatting__pzPJm svg {
  color: #283439;
}
.styles_root__WT9JN.styles_selected__6pyKO.styles_formatting__pzPJm {
  background-color: #eff3f6;
}
.styles_root__WT9JN.styles_selected__6pyKO.styles_formatting__pzPJm svg {
  color: #0074e0;
}
.styles_root__WT9JN[disabled], .styles_root__WT9JN:disabled {
  background-color: #f7f7f7;
  cursor: none;
  pointer-events: none;
}
.styles_root__WT9JN[disabled].styles_primary__7KgxL, .styles_root__WT9JN:disabled.styles_primary__7KgxL {
  background-color: #eff3f6;
}
.styles_root__WT9JN[disabled].styles_primary__7KgxL svg, .styles_root__WT9JN:disabled.styles_primary__7KgxL svg {
  color: #cfd8de;
}
.styles_root__WT9JN[disabled].styles_secondary__3pEIA, .styles_root__WT9JN:disabled.styles_secondary__3pEIA {
  background-color: #e6f2ff;
}
.styles_root__WT9JN[disabled].styles_secondary__3pEIA svg, .styles_root__WT9JN:disabled.styles_secondary__3pEIA svg {
  color: #b3daff;
}
.styles_root__WT9JN[disabled].styles_ghost__qunSQ, .styles_root__WT9JN:disabled.styles_ghost__qunSQ {
  background-color: transparent;
}
.styles_root__WT9JN[disabled].styles_ghost__qunSQ svg, .styles_root__WT9JN:disabled.styles_ghost__qunSQ svg {
  color: #cfd8de;
}
.styles_root__WT9JN[disabled].styles_formatting__pzPJm, .styles_root__WT9JN:disabled.styles_formatting__pzPJm {
  background-color: transparent;
}
.styles_root__WT9JN[disabled].styles_formatting__pzPJm svg, .styles_root__WT9JN:disabled.styles_formatting__pzPJm svg {
  color: #bfbfbf;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/icon-button/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_misc.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EEuBI,wBAAA;UAAA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EFlCA,yBAAA;EACA,kBAAA;AAuVJ;AEpTI;EACI,kBAAA;AFsTR;AAxVI;EACI,WAAA;AA0VR;AAvVI;EACI,kBAAA;AAyVR;AAtVI;EACI,kBAAA;AAwVR;AAtVQ;EACI,SAAA;AAwVZ;AArVQ;EACI,UAAA;AAuVZ;AApVQ;EACI,WAAA;AAsVZ;AAnVQ;EACI,YAAA;AAqVZ;AAjVI;EACI,yBAAA;AAmVR;AAjVQ;EACI,YAAA;AAmVZ;AA/UI;EACI,yBAAA;AAiVR;AA/UQ;EACI,cAAA;AAiVZ;AA7UI;EACI,6BAAA;AA+UR;AA7UQ;EACI,cAAA;AA+UZ;AA3UI;EACI,uBAAA;AA6UR;AA3UQ;EACI,cAAA;AA6UZ;AAzUI;EACI,6BAAA;AA2UR;AAzUQ;EACI,cAAA;AA2UZ;AAvUI;EAEI,cAAA;AAwUR;AArUI;EACI,uBAAA;EACA,yBAAA;AAuUR;AArUQ;EACI,cAAA;AAuUZ;AAnUI;EACI,yBAAA;AAqUR;AAnUQ;EACI,WAAA;AAqUZ;AAlUQ;EACI,yBAAA;AAoUZ;AAlUY;EACI,YAAA;AAoUhB;AAhUQ;EACI,yBAAA;AAkUZ;AAhUY;EACI,cAAA;AAkUhB;AA9TQ;EACI,yBAAA;AAgUZ;AA9TY;EACI,cAAA;AAgUhB;AA5TQ;EACI,uBAAA;AA8TZ;AA5TY;EACI,cAAA;AA8ThB;AAxTQ;EACI,yBAAA;AA0TZ;AAxTY;EACI,cAAA;AA0ThB;AAtTQ;EACI,yBAAA;AAwTZ;AAtTY;EACI,cAAA;AAwThB;AAnTI;EACI,yBAAA;AAqTR;AAnTQ;EACI,cAAA;AAqTZ;AAjTI;EAEI,yBAAA;EACA,YAAA;EACA,oBAAA;AAkTR;AAhTQ;EACI,yBAAA;AAkTZ;AAhTY;EACI,cAAA;AAkThB;AA9SQ;EACI,yBAAA;AAgTZ;AA9SY;EACI,cAAA;AAgThB;AA5SQ;EACI,6BAAA;AA8SZ;AA5SY;EACI,cAAA;AA8ShB;AA1SQ;EACI,6BAAA;AA4SZ;AA1SY;EACI,cAAA;AA4ShB","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    @include theme.reset-button();\n\n    background-color: theme.color(snow-100);\n    border-radius: theme.get-border-radius(md);\n\n    svg {\n        color: theme.color(space-300);\n    }\n\n    &.circular {\n        border-radius: theme.get-border-radius(rounded);\n    }\n\n    &.fab {\n        position: absolute;\n\n        &.top {\n            top: theme.spacing(1);\n        }\n\n        &.left {\n            left: theme.spacing(1);\n        }\n\n        &.right {\n            right: theme.spacing(1);\n        }\n\n        &.bottom {\n            bottom: theme.spacing(1);\n        }\n    }\n\n    &.primary {\n        background-color: theme.color(ocean-500);\n\n        svg {\n            color: theme.color(snow-50);\n        }\n    }\n\n    &.secondary {\n        background-color: theme.color(ocean-200);\n\n        svg {\n            color: theme.color(ocean-500);\n        }\n    }\n\n    &.ghost {\n        background-color: transparent;\n\n        svg {\n            color: theme.color(gray-400);\n        }\n    }\n\n    &.error {\n        background-color: theme.color(snow-50);\n\n        svg {\n            color: theme.color(red-500);\n        }\n    }\n\n    &.formatting {\n        background-color: transparent;\n\n        svg {\n            color: theme.color(space-500);\n        }\n    }\n\n    &[disabled] svg,\n    &:disabled svg {\n        color: theme.color(space-200);\n    }\n\n    &.border {\n        background-color: theme.color(snow-50);\n        border: 1px solid theme.color(gray-100);\n\n        svg {\n            color: theme.color(gray-300);\n        }\n    }\n\n    &:hover {\n        background-color: theme.color(snow-200);\n\n        svg {\n            color: theme.color(space-300);\n        }\n\n        &.primary {\n            background-color: theme.color(ocean-400);\n\n            svg {\n                color: theme.color(snow-50);\n            }\n        }\n\n        &.secondary {\n            background-color: theme.color(ocean-100);\n\n            svg {\n                color: theme.color(ocean-400);\n            }\n        }\n\n        &.ghost {\n            background-color: theme.color(gray-50);\n\n            svg {\n                color: theme.color(gray-400);\n            }\n        }\n\n        &.error {\n            background-color: theme.color(snow-50);\n\n            svg {\n                color: theme.color(red-500);\n            }\n        }\n\n        // TODO: The design uses a custom colors for this specific type of IconButton. This is not a good pattern.\n        //  Communicate this with the design and use consistent colors instead (remove this block).\n        &.border {\n            background-color: theme.color(ocean-50);\n\n            svg {\n                color: theme.color(gray-500);\n            }\n        }\n\n        &.formatting {\n            background-color: theme.color(gray-50);\n\n            svg {\n                color: theme.color(space-500);\n            }\n        }\n    }\n\n    &.selected.formatting {\n        background-color: theme.color(gray-50);\n\n        svg {\n            color: theme.color(ocean-500);\n        }\n    }\n\n    &[disabled],\n    &:disabled {\n        background-color: theme.color(snow-100);\n        cursor: none;\n        pointer-events: none;\n\n        &.primary {\n            background-color: theme.color(gray-50);\n\n            svg {\n                color: theme.color(gray-200);\n            }\n        }\n\n        &.secondary {\n            background-color: theme.color(ocean-50);\n\n            svg {\n                color: theme.color(ocean-200);\n            }\n        }\n\n        &.ghost {\n            background-color: transparent;\n\n            svg {\n                color: theme.color(gray-200);\n            }\n        }\n\n        &.formatting {\n            background-color: transparent;\n\n            svg {\n                color: theme.color(space-200);\n            }\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:math';\n@use 'sass:meta';\n@use './colors';\n\n@function if-important($important) {\n    @return #{if($important, '!important', '')};\n}\n\n@function strip-unit($value) {\n    @if meta.type-of($value) == 'number' and not math.is-unitless($value) {\n        @return math.div($value, ($value * 0 + 1));\n    }\n\n    @return $value;\n}\n\n@function is-map($variable) {\n    @return meta.type-of($variable) == 'map';\n}\n\n@function is-string($variable) {\n    @return meta.type-of($variable) == 'string';\n}\n\n// Reset the button to behave like div\n@mixin reset-button() {\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    color: inherit;\n    cursor: pointer;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    position: relative;\n    -webkit-tap-highlight-color: transparent;\n    text-align: left;\n    text-decoration: none;\n    user-select: none;\n    vertical-align: middle;\n\n    &::-moz-focus-inner {\n        border-style: none;\n    }\n}\n\n@mixin scrollbar() {\n    // The new standard syntax (Currently only supported in Firefox)\n    scrollbar-color: colors.color(gray-200) colors.color(snow-50);\n    scrollbar-width: thin;\n\n    // For Chrome, Edge, Safari, and Opera\n    ::-webkit-scrollbar {\n        height: 7px;\n        width: 5px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background: colors.color(gray-200);\n        border-radius: 5px;\n    }\n\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n        background: colors.color(gray-200);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__-ESDC`,
	"ocean-50": `styles_ocean-50__Zb3Ci`,
	"ocean-100": `styles_ocean-100__Xpo7V`,
	"ocean-200": `styles_ocean-200__v7GHb`,
	"ocean-300": `styles_ocean-300__OSWri`,
	"ocean-400": `styles_ocean-400__1MLIl`,
	"ocean-500": `styles_ocean-500__EjCkT`,
	"ocean-600": `styles_ocean-600__oXSVH`,
	"space-50": `styles_space-50__rO64w`,
	"space-100": `styles_space-100__v0ff9`,
	"space-200": `styles_space-200__LuWLo`,
	"space-300": `styles_space-300__znA05`,
	"space-400": `styles_space-400__3ws1r`,
	"space-500": `styles_space-500__YkJEF`,
	"gray-50": `styles_gray-50__LJAPl`,
	"gray-100": `styles_gray-100__-pneb`,
	"gray-200": `styles_gray-200__6LaGp`,
	"gray-300": `styles_gray-300__IdnRw`,
	"gray-400": `styles_gray-400__rPE-0`,
	"gray-500": `styles_gray-500__7Blft`,
	"green-50": `styles_green-50__+aSyG`,
	"green-100": `styles_green-100__K7Xes`,
	"green-200": `styles_green-200__l6WYw`,
	"green-300": `styles_green-300__-fh4s`,
	"green-400": `styles_green-400__9OJvW`,
	"green-500": `styles_green-500__VH5rk`,
	"red-50": `styles_red-50__mVc0+`,
	"red-100": `styles_red-100__Y08IO`,
	"red-200": `styles_red-200__c1rI4`,
	"red-300": `styles_red-300__mu-8c`,
	"red-400": `styles_red-400__0Mk2g`,
	"red-500": `styles_red-500__H0asz`,
	"yellow-50": `styles_yellow-50__CaR5a`,
	"yellow-100": `styles_yellow-100__sUjoV`,
	"yellow-200": `styles_yellow-200__NdrML`,
	"yellow-300": `styles_yellow-300__VU-+6`,
	"yellow-400": `styles_yellow-400__SIp2o`,
	"yellow-500": `styles_yellow-500__+1i8I`,
	"orange-50": `styles_orange-50__rMEMQ`,
	"orange-100": `styles_orange-100__qaLQi`,
	"orange-200": `styles_orange-200__a+ToD`,
	"orange-300": `styles_orange-300__mF4DN`,
	"orange-400": `styles_orange-400__HHTf4`,
	"orange-500": `styles_orange-500__3p6ey`,
	"turquoise-50": `styles_turquoise-50__VDjn2`,
	"turquoise-100": `styles_turquoise-100__6xfKi`,
	"turquoise-200": `styles_turquoise-200__C0qxm`,
	"turquoise-300": `styles_turquoise-300__A5TWM`,
	"turquoise-400": `styles_turquoise-400__tktt6`,
	"turquoise-500": `styles_turquoise-500__3j-fZ`,
	"turquoise-600": `styles_turquoise-600__z9g4o`,
	"violet-50": `styles_violet-50__5F6fT`,
	"violet-100": `styles_violet-100__PN65M`,
	"violet-200": `styles_violet-200__V4XwS`,
	"violet-300": `styles_violet-300__vt-MA`,
	"violet-400": `styles_violet-400__772O4`,
	"violet-500": `styles_violet-500__ulpDo`,
	"snow-50": `styles_snow-50__RqKI3`,
	"snow-100": `styles_snow-100__vNOD3`,
	"snow-200": `styles_snow-200__FuZ+d`,
	"snow-300": `styles_snow-300__B5VWq`,
	"snow-400": `styles_snow-400__3i4ch`,
	"snow-500": `styles_snow-500__E11cZ`,
	"background-color": `styles_background-color__R77OE`,
	"ocean": `styles_ocean__SIBg3`,
	"ocean-light": `styles_ocean-light__XIZaS`,
	"green": `styles_green__5+gQ+`,
	"green-light": `styles_green-light__xygeh`,
	"red": `styles_red__1m+wi`,
	"red-light": `styles_red-light__Gh6Yb`,
	"orange": `styles_orange__K6JZS`,
	"orange-light": `styles_orange-light__U5IbR`,
	"space": `styles_space__WWdql`,
	"space-light": `styles_space-light__MOUG-`,
	"gray-light": `styles_gray-light__Qa1xJ`,
	"violet": `styles_violet__GWvJj`,
	"violet-light": `styles_violet-light__Y9ry9`,
	"yellow": `styles_yellow__y5Gxe`,
	"yellow-light": `styles_yellow-light__kAOV2`,
	"root": `styles_root__WT9JN`,
	"circular": `styles_circular__PtEtM`,
	"fab": `styles_fab__unop9`,
	"top": `styles_top__BBlVW`,
	"left": `styles_left__cjlrG`,
	"right": `styles_right__cslSk`,
	"bottom": `styles_bottom__3Vn5S`,
	"primary": `styles_primary__7KgxL`,
	"secondary": `styles_secondary__3pEIA`,
	"ghost": `styles_ghost__qunSQ`,
	"error": `styles_error__hig-v`,
	"formatting": `styles_formatting__pzPJm`,
	"border": `styles_border__evxv3`,
	"selected": `styles_selected__6pyKO`
};
export default ___CSS_LOADER_EXPORT___;
